import React, { useRef } from 'react'
import { Button } from 'reactstrap'
import { LOCALSTORAGE_STATE_KEY } from 'web/utils/local-storage'
import { assertDefined } from 'web/utils/utils'

/**
 * AI gunk
 */
export const RestoreBackupButton: React.FC = () => {
    const fileInputRef = useRef<HTMLInputElement>(null)

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0]
        if (file) {
            const reader = new FileReader()

            reader.onload = (e) => {
                const result = e.target?.result
                if (result != null) {

                    try {
                        assertDefined(result)
                        JSON.parse(result as string)

                        localStorage.setItem(LOCALSTORAGE_STATE_KEY, result as string)
                        window.location.reload()
                    } catch (error) {
                        console.error(error)
                    }

                } else {

                    console.error('Failed to read file')

                }
            }

            reader.readAsText(file)
        }
    }

    const handleRestoreClick = () => {
        fileInputRef.current?.click()
    }

    return (
        <div>
            <input
                type='file'
                ref={fileInputRef}
                style={{ display: 'none' }}
                onChange={handleFileChange}
                accept='.json,.txt'
            />
            <Button
                onClick={handleRestoreClick}
                size='sm'
                outline
            >
                {'Restore'}
            </Button>
        </div>
    )
}
